import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Student} from '../../student/student.model';
import {UserPreferencesService} from '../../user-preferences/user-preferences.service';
import {TylerMatTableDataSource} from '../../angular-material/extended.class';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import { cloneDeep } from 'lodash';
@Component({
    selector: 'app-student-list-modal',
    templateUrl: './student-list-modal.component.html',
    styleUrls: ['./student-list-modal.component.css'],
})
export class StudentListModalComponent implements OnInit, AfterViewInit {
    students: Student[] = [];
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    displayedColumns: string[] = ['StudentNumber', 'fullName', 'EnrollmentStatus', 'Grade', 'EnrollmentSchool' ];
    angularMatData = new TylerMatTableDataSource();
    constructor(
        private dialogRef: MatDialogRef<StudentListModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: Student[],
        private userPreferences: UserPreferencesService
    ) {
        this.students = cloneDeep(this.data);
        if (this.userPreferences.generalPreferences == null || this.userPreferences.generalPreferences.StudentNameFormat == 'LNF') {
            this.sortByLastName();
        } else {
            this.sortByFirstName();
        }
        this.angularMatData.data = this.students;
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.angularMatData.paginator = this.paginator;
        this.angularMatData.sort = this.sort;
    }

    closeClick(message: string) {
        this.dialogRef.close(message);
    }

    sortByFirstName() {
        this.students = this.students.sort(function (a, b) {
            if (a.FirstName < b.FirstName) {
                return -1;
            }
            if (a.FirstName > b.FirstName) {
                return 1;
            }
            return 0;
        });
    }

    sortByLastName() {
        this.students = this.students.sort(function (a, b) {
            if (a.LastName < b.LastName) {
                return -1;
            }
            if (a.LastName > b.LastName) {
                return 1;
            }
            return 0;
        });
    }
}
